import ZkToolBar from './src/main'
ZkToolBar.install = function (Vue) {
  Vue.component(ZkToolBar.name, ZkToolBar)
}
export default ZkToolBar



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/toolBar/index.js